import React from "react";
import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";
import { useSegment } from "analytics/segment";
import { useAppDispatch, useAppSelector } from "core/store";
import { ReportType, setReportType } from "reports/slice";

const Clickable = styled.div<{ isSelected: boolean }>`
  color: ${colors.gray1};
  cursor: pointer;
  font-size: 1.143rem;
  font-weight: ${props => (props.isSelected ? "bold" : "normal")};
  line-height: 1.714rem;
  margin-inline-end: 1.714rem;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ReportTypePicker = () => {
  const reportType = useAppSelector(state => state.reports.reportType);
  const dispatch = useAppDispatch();
  const { track } = useSegment();

  const onClick = (newReportType: ReportType) => {
    dispatch(setReportType(newReportType));
    track({
      eventName: "set_report_type",
      action: "click",
      element: "report_type_picker",
      props: {
        reportType: newReportType,
      },
    });
  };

  return (
    <Container>
      <Clickable
        isSelected={reportType === ReportType.Buildings}
        onClick={() => onClick(ReportType.Buildings)}
      >
        By Building
      </Clickable>
      <Clickable
        isSelected={reportType === ReportType.Individuals}
        onClick={() => onClick(ReportType.Individuals)}
      >
        By Individual
      </Clickable>
    </Container>
  );
};
